import { render, staticRenderFns } from "./BioModelTree.vue?vue&type=template&id=43020b85&"
import script from "./BioModelTree.vue?vue&type=script&lang=js&"
export * from "./BioModelTree.vue?vue&type=script&lang=js&"
import style0 from "./BioModelTree.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "BioModelTree.vue"
export default component.exports